import { ProductionTitle } from "@/orval/gen/model/productionTitle"
import { Text, TextProps } from "@mantine/core"
interface Props extends Omit<TextProps, "fw"> {
  productionTitle: ProductionTitle
}
export function ProductionTitleText({ productionTitle, ...props }: Props) {
  return (
    <Text
      {...props}
      fw={productionTitle.isPerformance ? "bold" : undefined}
      {...(productionTitle.isCanceld && { td: " line-through" })}
      {...(productionTitle.isRequested && { fs: "italic" })}
    >
      {productionTitle.isPerformance
        ? productionTitle.text?.toUpperCase()
        : productionTitle.text}
    </Text>
  )
}
